import React, { ChangeEvent, FC, InputHTMLAttributes, MouseEvent } from 'react';
import { IconHeartRegular, IconHeartSolid } from '@croquiscom-pvt/zds';

import { useProductCardContext } from '../../../context/ProductCardContext';
import { useLike } from '../../../hooks/useLike';
import IconGridHeartOutlined from './grid-heart-outlined.svg';
import IconGridHeartSolid from './grid-heart-solid.svg';
import { Root } from './Like.styled';

const SIZE_LOOKUP = {
  sm: 22,
  md: 28,
  lg: 32,
};

export interface LikeProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> {
  /**
   * 아이콘 사이즈
   * sm: 소형 그리드 타입 상품 카드에 사용
   * md: 리스트 타입 상품 카드에 사용
   * lg: 대형 그리드 타입 상품 카드에 사용
   */
  size: 'sm' | 'md' | 'lg';
  /**
   * 사용할 아이콘 타입
   * list: 리스트형 상품 카드에서 노출될 경우
   * grid: 그리드형 상품 카드에서 노출 될 경우
   */
  iconType?: 'list' | 'grid';
}

/**
 * 상품 찜 버튼
 */
export const Like: FC<React.PropsWithChildren<LikeProps>> = ({ style, className, type = 'checkbox', iconType = 'grid', size, ...rest }) => {
  const {
    catalog_product_id,
    shop_product_no,
    product_url,
    image_url,
    title,
    shop_id,
    browsing_type,
    zpay,
    final_price,
    free_shipping,
    discount_rate,
  } = useProductCardContext();
  const { like, toggleLike } = useLike({ catalog_product_id: catalog_product_id ?? '' });

  const onCheckboxChange = async (e: ChangeEvent<HTMLInputElement>) => {
    rest.onChange?.(e);
    await toggleLike({
      like: e.target.checked,
      catalogProductId: catalog_product_id,
      shopId: +shop_id,
      shopProductNo: shop_product_no,
      browsingType: browsing_type,
      goodsUrl: product_url ?? '',
      imageUrl: image_url ?? '',
      isZpay: zpay ?? false,
      price: final_price,
      isFreeShipping: free_shipping ?? false,
      title: title ?? '',
      discountRate: discount_rate ?? 0,
    });
  };

  const onClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
  };

  const renderIcon = () => {
    if (iconType === 'list') {
      return like ? <IconHeartSolid v3Color='red200' /> : <IconHeartRegular v3Color='gray400' />;
    }
    return <img src={like ? IconGridHeartSolid : IconGridHeartOutlined} alt='좋아요' />;
  };

  return (
    <Root style={style} className={className} size={SIZE_LOOKUP[size]} onClick={onClick}>
      {renderIcon()}
      <input {...rest} type={type} checked={like} onChange={onCheckboxChange} />
    </Root>
  );
};
